<select 
#select
class="form-control" 
[name]="name"
[id]="id"
[required]="required"
[disabled]="disabled"
[ngModel]="ngModel || ''" 
(ngModelChange)="onChange($event ? $event : null)">
<option value=""></option>
<option *ngFor="let grupo of grupos" [ngValue]="grupo.id" [disabled]="isSituacaoInativo(grupo.situacao)">{{grupo.nome}}</option>
</select>  